import { createVNode as l, mergeProps as i } from "vue";
import s from "../node_modules/@pf-ui/pf-icon-svg/es/asn/HospitalFilled.js";
import a from "../components/PfIcon.js";
const t = (o, r) => {
  const e = {
    ...o,
    ...r.attrs
  };
  return l(a, i(e, {
    icon: s
  }), null);
};
t.displayName = "HospitalFilled";
t.inheritAttrs = !1;
export {
  t as default
};
